import {WaveLoader} from '@wandb/weave/components/Loaders/WaveLoader';
import React from 'react';

export interface LogLoadingContext {
  isLoadingPrevious: boolean;
}

export const LogLoadingIndicator: React.FC<{context?: LogLoadingContext}> = ({
  context,
}) => {
  if (!context?.isLoadingPrevious) {
    return null;
  }

  return (
    // Use minimum of '12px' top padding to give enough space for wave loader.
    <div className="flex items-center justify-center py-12">
      <WaveLoader size="small" />
    </div>
  );
};
